var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 59,
    viewBox: "0 0 85 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Visa/Logo"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.500305,
    y: 0.550477,
    width: 83,
    height: 57,
    rx: 3.5,
    transform: "rotate(-0.03491 0.500305 0.550477)",
    fill: "#EFF0F4",
    stroke: "#EFF0F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon9",
    d: "M37.3197 39.8054L31.7272 39.8088L35.2128 19.5057L40.805 19.5023L37.3197 39.8054Z",
    fill: "#15195A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    d: "M57.5807 19.9888C56.4773 19.5787 54.7275 19.1263 52.5641 19.1276C47.0414 19.131 43.154 21.8976 43.1325 25.8496C43.0884 28.7655 45.9197 30.3833 48.0372 31.3542C50.2015 32.3464 50.9374 32.9943 50.9379 33.8799C50.9167 35.2399 49.1908 35.8679 47.5806 35.8689C45.3478 35.8702 44.1513 35.5477 42.3327 34.7922L41.5961 34.4683L40.8163 39.0259C42.1283 39.586 44.5452 40.0822 47.0541 40.1025C52.9222 40.099 56.7408 37.3751 56.7835 33.1636C56.8044 30.8526 55.3088 29.0827 52.0858 27.6377C50.1292 26.71 48.931 26.0844 48.9304 25.134C48.9528 24.2699 49.9425 23.3844 52.1505 23.383C53.9686 23.3386 55.3046 23.7479 56.3168 24.1578L56.8228 24.3731L57.5807 19.9888Z",
    fill: "#15195A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.5913 19.4873L71.9171 19.4847L76.4412 39.7826L71.2631 39.7858C71.2631 39.7858 70.7549 37.4536 70.5939 36.7409L63.4136 36.7453C63.2063 37.2851 62.2417 39.7913 62.2417 39.7913L56.3737 39.7949L64.6693 21.1735C65.244 19.8556 66.2573 19.4881 67.5913 19.4873ZM67.2513 26.9165C67.2513 26.9165 65.4818 31.4314 65.0219 32.598L69.6704 32.5951C69.4398 31.5803 68.3778 26.7215 68.3778 26.7215L67.9859 24.9725C67.8216 25.4231 67.5839 26.0425 67.4236 26.4603C67.315 26.7435 67.2419 26.9341 67.2513 26.9165Z",
    fill: "#15195A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.48365 19.5234L16.4814 19.5179C17.7011 19.5599 18.6909 19.9265 19.0137 21.2228L20.9747 30.5482C20.975 30.5491 20.9752 30.55 20.9755 30.5509L21.5757 33.3582L27.0442 19.5115L32.9578 19.5079L24.1797 39.7927L18.2658 39.7963L13.2705 22.1596C11.5501 21.2169 9.58675 20.459 7.39185 19.9336L7.48365 19.5234Z",
    fill: "#15195A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.deb77c5d.svg";
export { ForwardRef as ReactComponent };